import React from "react";
import Utils from "../../js/utils";
import Graph from "./graph.jsx";
import GraphFooter from "./footer/graphFooter.jsx";
import {getAgrCount} from "./graphUtils.js";

class SimpleGraph extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            chart: null,
            graphData: null,
            stats: {},
        };
    }

    setChartInstance = (key, data) => this.setState({ [key]: data });

    setGraphData = (dataO, data, timestamp, stats) => {
        const componentProbe = Utils.getPropertyOfObject(['ipDetails', 'probe'], this.props);
        const componentIP = Utils.getPropertyOfObject(['selectedIP'], this.props);
        const dataProbe = Utils.getPropertyOfObject(['probe'], stats);
        const dataIP = Utils.getPropertyOfObject(['ip'], stats);
        // local probe or IP might have change before the callback returned
        if (componentProbe === dataProbe && componentIP === dataIP) {
            let graphDataNew = data;
            if (this.props.ipDetails.graphType === 'advanced') {
                graphDataNew = DataAdvanced.getDisplayData(data, this.props.theme.shadowReverse);
            }
            this.setState({
                originalData: dataO,
                graphData: graphDataNew,
                stats,
            });
        }
    }

    loadGraph = ({ ip, ipDetails, callback }) => {
        const { epoch, probe, graphType, endPoint } = ipDetails;
        const end = endPoint === undefined ? Utils.getTimeNow() : endPoint;
        const chartWidth = Utils.getChartLineWidth(this.props.isMobile, this.props.isNarrow);
        const agrCount = getAgrCount({ipDetails, chartWidth });
        if(graphType === 'basic'){
            DataBasic.loadData(ip, end, epoch, agrCount, probe, callback)
        } else {
            DataAdvanced.loadData(ip, end, epoch, agrCount, probe, callback)
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.ipDetails != this.props.ipDetails ||
            prevProps.selectedIP != this.props.selectedIP ||
            prevProps.theme != this.props.theme ||
            prevProps.isNarrow != this.props.isNarrow ||
            prevState.customDebugAgrCount != this.state.customDebugAgrCount
        ) {
            this.loadGraph({ ip: this.props.selectedIP, ipDetails: this.props.ipDetails, callback: this.setGraphData});
        }
    }

    componentDidMount() {
        if (Utils.isSet(this.props.selectedIP)) {
            this.loadGraph({ ip: this.props.selectedIP, ipDetails: this.props.ipDetails, callback: this.setGraphData});
        }
    }

    render() {
        return (
            <div className='divCol' id={this.props.ipDetails.probe}>
                <Graph
                    graphData={this.state.graphData}
                    originalData={this.state.originalData}
                    stats={this.state.stats}
                    setChartInstance={this.setChartInstance}
                    setEpochFromZoom={this.props.setEpochFromZoom}
                    {...this.props}
                />
                <GraphFooter
                    ipDetails={this.props.ipDetails}
                    isMobile={this.props.isMobile}
                    chart={this.state.chart}
                    graphData={this.state.graphData}
                    stats={this.state.stats}
                    pxWidth={this.props.chartWidth}
                />
            </div>
        );
    }
}


export default SimpleGraph;
